var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Base from 'react-icon-base';
import classnames from 'classnames';
import IconsMap from './mapping/iconsMap';
const BaseIcon = props => {
    const { name, className, style } = props, other = __rest(props, ["name", "className", "style"]);
    const classNames = classnames({
        [className || '']: className || '',
    });
    return (<span role="img" className={`anticon cuk2-icon-${name.toLowerCase()} ${classNames}`}>
      <Base 
    // @ts-ignore
    viewBox={IconsMap[name].viewBox} style={Object.assign({ verticalAlign: 'baseline' }, style)} {...other}>
        {
    // @ts-ignore
    IconsMap[name].svg}
      </Base>
    </span>);
};
export default BaseIcon;
